// util/validacoes.js
import React from "react";

export function isDataValida(dataStr) {
    if (!dataStr || dataStr.length !== 10) return false;

    const [dia, mes, ano] = dataStr.split('/').map(Number);
    if (isNaN(dia) || isNaN(mes) || isNaN(ano)) return false;

    const data = new Date(ano, mes - 1, dia);

    return (
        data.getFullYear() === ano &&
        data.getMonth() === mes - 1 &&
        data.getDate() === dia
    );
}

/**
 * Remove todos os caracteres não numéricos de uma string
 */
export const somenteNumeros = (valor) => {
    return valor.replace(/\D/g, '');
};

/**
 * Valida se o valor é um número (inteiro ou decimal)
 */
export const isNumero = (valor) => {
    const numero = parseFloat(valor.toString().replace(',', '.'));
    return !isNaN(numero);
};

/**
 * Valida se um CNPJ é válido
 */
export const validarCNPJ = (cnpj) => {
    cnpj = somenteNumeros(cnpj);

    if (!cnpj || cnpj.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(\d)\1+$/.test(cnpj)) return false;

    const calcDigito = (cnpj, pesos) => {
        let soma = 0;
        for (let i = 0; i < pesos.length; i++) {
            soma += parseInt(cnpj.charAt(i)) * pesos[i];
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const digito1 = calcDigito(cnpj, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const digito2 = calcDigito(cnpj + digito1, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

    return cnpj.endsWith(`${digito1}${digito2}`);
};

/**
 * Valida se um e-mail está no formato correto
 */
export const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

/**
 * Valida se o valor tem somente letras (com ou sem acento)
 */
export const somenteLetras = (texto) => {
    return /^[A-Za-zÀ-ú\s]+$/.test(texto);
};


/**
 * Formata número para decimal com 2 casas e vírgula
 * Exemplo: "50000" => "50.000,00"
 */
export const formatarMoeda = (valor) => {
    const numero = parseFloat(somenteNumeros(valor)) / 100;
    return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
};

export const formatarKwh10_2 = (valor) => {
    // 1) força valor pra string (evita replace em undefined/number/etc)
    const s = valor != null ? String(valor) : '';

    // 2) remove tudo que não é dígito, vírgula ou ponto
    const clean = s.replace(/[^\d,\.]/g, '');

    // 3) substitui vírgula por ponto e converte
    const num = parseFloat(clean.replace(',', '.'));
    if (isNaN(num)) {
        return '0,00';
    }

    // 4) limita ao máximo permitido
    const capped = Math.min(num, 99999999.99);

    // 5) formata de volta pra pt-BR com 2 decimais
    return capped.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

/**
 * Formatação referente ao valor de %
 *
 */

//Recebe um número ou string, limpa, limita até 100 e formata "99,99 %".
export function formatarPercentual(n) {
    // se for número puro, já transforma em string
    const raw = typeof n === 'number' ? String(n) : n;
    const cleaned = raw.replace(/[^\d,\.]/g, '').replace(',', '.');
    const num = parseFloat(cleaned);
    if (isNaN(num)) return '';
    return Math.min(num, 100)
            .toFixed(2)
            .replace('.', ',')
        + ' %';
}

export const mesesOptions = () =>
    [...Array(12)].map((_, i) => (
        <option key={i + 1} value={i + 1}>
            {new Date(0, i).toLocaleString('pt-BR', {month: 'long'}).replace(/^\w/, c => c.toUpperCase())}
        </option>
    ));

export const formatDocumento = (value) => {
    if (!value) return '';
    return value.length > 11
        ? value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, "$1.$2.$3/$4-$5")
        : value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, "$1.$2.$3-$4");
};


